import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorModal from "../Security/ErrorModal"; // Adjust path if necessary
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom"; // NEW: useLocation
import IFramePage from "../FindCare/IFramePage";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const ProviderList = () => {
  const { t } = useTranslation();
  const location = useLocation(); // NEW
  const navigate = useNavigate();
  // Redux / Auth bits
  const token = localStorage.getItem('AccessToken');
  const contract = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso?.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  // Chat
  const { isChatVisible, toggleChat, showChat } = useChat();

  // UI/Data state
  const [providers, setProviders] = useState([]);
  const [error, setError] = useState(null);
  const [showProviderDetails, setShowProviderDetails] = useState(false);
  const [selectedProviderType, setSelectedProviderType] = useState("");
  const [providerDetails, setProviderDetails] = useState([]);
  const [doulasCategories, setDoulasCategories] = useState([]);
  const [showDoulasCategories, setShowDoulasCategories] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showNurseModal, setShowNurseModal] = useState(false);
  const [showReproductiveModal, setShowReproductiveModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [redirectLink, setRedirectLink] = useState("");
  const [providersContent, setProvidersContent] = useState("");
  const [showConfirmButtons, setShowConfirmButtons] = useState(false);
  const [treatmentCostEstimator, setTreatmentCostEstimator] = useState("N");
  // --- NEW: detect external access from query params ---
  const { isExternal, externalParams } = useMemo(() => {
    const sp = new URLSearchParams(location.search);
    const qMemberID = sp.get("MemberID");
    const qContract = sp.get("Contract");
    const qDeviceType = sp.get("DeviceType") || "PatientPortal";
    const found = !!(qMemberID && qContract);
    return {
      isExternal: found,
      externalParams: found
        ? {
            MemberID: qMemberID,
            Contract: qContract,
            ContractIdentified: qContract,
            DeviceType: qDeviceType,
            EmailID: "", // unknown on deep-link, backend should not rely on it
            Premiere: "No", // default; can’t infer—override if you can detect
            BenefitsOverview: "", // unknown here
          }
        : null,
    };
  }, [location.search]);
const isDrilledIn = showProviderDetails ;
const shouldShowBack = !isExternal || isDrilledIn;
  // --- NEW: a single source of truth for user fields ---
  const effectiveUser = useMemo(() => {
    if (isExternal && externalParams) return { userData: externalParams };
    return contract; // normal flow
  }, [isExternal, externalParams, contract]);

  // --- NEW: Hide header (and optionally chat) in external mode ---
//   useEffect(() => {
//     if (isExternal) {
//       document.body.classList.add("hide-header");
//       // Optional: hide chat in external mode (remove if undesired)
//       // if (isChatVisible) toggleChat();
//     }
//     return () => {
//       if (isExternal) {
//         document.body.classList.remove("hide-header");
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isExternal]);

  // --- helper: build axios headers consistently ---
  const authHeaders = useMemo(() => {
    const base = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    // Only set Authorization if token exists
    if (token) base.Authorization = `Bearer ${token}`;
    return base;
  }, [token]);
 useEffect(() => {
    const email = effectiveUser?.userData?.EmailID || "";
    const memberid = effectiveUser?.userData?.MemberID || "";
    // if (!email) return; // skip if no email (likely external)
    const fetchBenefits = async () => {
      const payload = {
        _Params: JSON.stringify({ EmailID: email, MemberID : memberid,DeviceType: "PatientPortal" }),
      };
      try {
        const response = await axios.post(Endpoints.UnderstandingBenefits, payload, {
          headers: authHeaders,
        });
        setTreatmentCostEstimator(response.data?.TreatmentCostEstimator || "N");
        setProvidersContent(response.data?.BenefitsOverview || "");
        if (response.data?.Premier !== undefined && isExternal) {
          effectiveUser.userData.Premiere = response.data.Premier;
          effectiveUser.userData.BenefitsOverview = response.data.BenefitsOverview;
        }
      } catch (err) {
        console.error("Error fetching benefits:", err);
      }
    };
    fetchBenefits();
  }, [effectiveUser?.userData]);  
  // Fetch providers (runs in both modes)
  useEffect(() => {
    // If you absolutely must block calls without token in internal mode:
    // if (!token && !isExternal) return;
    fetchProviders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, isExternal, effectiveUser?.userData?.MemberID, effectiveUser?.userData?.ContractIdentified]);

  // Understanding Benefits (internal-only if you need EmailID)
  useEffect(() => {
    const email = effectiveUser?.userData?.EmailID || "";
    const memberID = effectiveUser?.userData?.MemberID || "";
    // if (!email) return; // skip if no email (likely external)
    const fetchBenefits = async () => {
      const payload = {
        _Params: JSON.stringify({ EmailID: email, MemberID: memberID,DeviceType: "PatientPortal" }),
      };
      try {
        const response = await axios.post(Endpoints.UnderstandingBenefits, payload, {
          headers: authHeaders,
        });
        setTreatmentCostEstimator(response.data?.TreatmentCostEstimator || "N");
      } catch (err) {
        console.error("Error fetching benefits:", err);
      }
    };
    fetchBenefits();
  }, [effectiveUser?.userData]);  

  // If non-Premier & have feed link, load content
  useEffect(() => {
    const userTypePremier = effectiveUser?.userData?.Premiere;
    const feedLinks = effectiveUser?.userData?.BenefitsOverview;
    if (userTypePremier === "No" && feedLinks) {
      fetchFeedContent(feedLinks);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectiveUser?.userData?.Premiere, effectiveUser?.userData?.BenefitsOverview]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         doulasCategories.current &&
//         !doulasCategories.current.contains(event.target) &&
//         !event.target.closest('.schedule-block')
//       ) {
//         setShowDoulasCategories(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [showDoulasCategories]);

  // ---------------- API helpers ----------------

  const fetchFeedContent = async (feedLinks) => {
    try {
      if (!feedLinks) return;
      const params = {
        URL: feedLinks,
        DeviceType: "PatientPortal",
        EmailID: effectiveUser?.userData?.EmailID || "",
      };

      const response = await axios.post(
        Endpoints.Getjson,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: authHeaders }
      );

      const responseData = response.data;
      const providersData = responseData?.rss?.channel?.item?.providers;
      if (providersData) {
        const providersArray = providersData.provider || [];
        const providerText =
          providersData.providertext?.["#cdata-section"] ||
          providersData.providertext ||
          "";

        const providersHTML = `
          <providers>
            ${providersArray
              .map(
                (provider) => `
              <provider>
                <providerlink>${provider.providerlink || ""}</providerlink>
                <providerlogo>${provider.providerlogo || ""}</providerlogo>
              </provider>
            `
              )
              .join("")}
            ${providerText ? `<providertext>${providerText}</providertext>` : ""}
          </providers>
        `;
debugger
        setProvidersContent(providersHTML);
        console.log(t('providersuccessfullyset'), providersHTML);
      } else {
        console.error("No <providers> tag found in the feed.");
      }
    } catch (error) {
      console.error(t('errorfetchingfeed'), error?.message);
    }
  };

  const fetchProviders = async () => {
    try {
      const params = {
        MemberID: effectiveUser?.userData?.MemberID,
        Contract: effectiveUser?.userData?.Contract || effectiveUser?.userData?.ContractIdentified,
        DeviceType: effectiveUser?.userData?.DeviceType || "PatientPortal",
        EmailID: effectiveUser?.userData?.EmailID || "",
      };

      // Guard: need minimum MemberID + Contract
      if (!params.MemberID || !params.Contract) {
        setError(t('noprovidersfound'));
        return;
      }

      const response = await axios.post(
        Endpoints.loadprovidersearchfeed,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: authHeaders }
      );

      if (response.data) {
        const filteredProviders = response.data.filter(
          (p) => p.ProviderType !== "Special Access Provider Available" && p.Visibility === "Yes"
        );
        setProviders(filteredProviders);
      } else {
        setError(t('noprovidersfound'));
      }
    } catch (err) {
      console.error(t('errorfetchingproviders'), err);
      setError(t('errorfetchingproviders'));
    }
  };

  const fetchProviderDetails = async (providerType) => {
    setSelectedProviderType(providerType);
    setShowProviderDetails(true);

    try {
      const params = {
        MemberID: effectiveUser?.userData?.MemberID,
        ProviderType: providerType,
        Contract: effectiveUser?.userData?.Contract || effectiveUser?.userData?.ContractIdentified,
        DeviceType: effectiveUser?.userData?.DeviceType || "PatientPortal",
        EmailID: effectiveUser?.userData?.EmailID || "",
      };

      const response = await axios.post(
        Endpoints.LoadNonPhysicianProviders,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: authHeaders }
      );

      if (response.data) {
        const sorted = response.data.sort((a, b) => b.IsFavourite.localeCompare(a.IsFavourite));
        setProviderDetails(sorted);
      } else {
        setError(`No providers found for ${providerType}.`);
      }
    } catch (err) {
      setError(`Error fetching ${providerType} details.`);
    }
  };

  
  const OidcIntegration =async(vendor)=>{
    const params = {
      emailId:effectiveUser?.userData?.EmailID,
      vendor : vendor,
    };
try {
    // Making the API call
    const response = await axios.post(
      Endpoints.OidcIntegration,
      `_Params=${encodeURIComponent(JSON.stringify(params))}`,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        }
      }
    );
    if (response?.data) {
      window.open(response?.data, "_blank");
    }
  } catch (error) {
    setError(error);
  }   finally {
  // setLoading(false); // <-- Ensure loading is set to false after fetch
}
  };

  // ---------------- Handlers (unchanged except where noted) ----------------

  const handleProviderClick = (provider) => {
    const userTypePremier = effectiveUser?.userData?.Premiere;
    const { ProviderType, Message, RedirectLink } = provider;
    if (ProviderType === "Reproductive Endocrinologists/Infertility") {
      if (userTypePremier === "No" ) {
        if (!providersContent) return;
        console.log(providersContent);
        navigate(`/iframe-page${location.search}`, {
          state: {
            htmlContent: providersContent,
            externalData: isExternal ? externalParams : null
          },
        });
      } else {
        // Pass both external data and provider type to map search
        navigate(`/map-search${location.search}`, {
          state: {
            selectedProviderType: "Reproductive Endocrinologists/Infertility",
            externalData: isExternal ? externalParams : null
          },
          search: location.search // Preserve query parameters
        });
      }
    }

    if (ProviderType === "Doulas") {
      setShowDoulasCategories((prev) => !prev);
      setDoulasCategories([
        { label: "All Categories", checked: false },
        { label: "Prenatal", checked: false },
        { label: "At Birth", checked: false },
        { label: "Postpartum", checked: false },
        { label: "Lactation Support", checked: false },
      ]);
      return;
    }
    if (ProviderType === "Pediatric Behavioral Health") {

      OidcIntegration("Bend");
      return;
    }
    if(ProviderType === "Pediatric Virtual Network"){
      navigate("/pediatric-care");
      return;
    }
    if (Message) {
      setModalMessage(Message);
      setRedirectLink(RedirectLink);
      setShowModal(true);
      setShowConfirmButtons(Boolean(RedirectLink));
    } else if (RedirectLink) {
      window.open(RedirectLink, "_blank");
    } else {
      fetchProviderDetails(ProviderType);
    }
  };

  const toggleFavorite = async (providerIndex) => {
    if (!providerDetails[providerIndex]) return;

    try {
      const provider = providerDetails[providerIndex];
      const updatedIsFavourite = provider.IsFavourite === "Y" ? "N" : "Y";

      const params = {
        Contract: effectiveUser?.userData?.Contract || effectiveUser?.userData?.ContractIdentified,
        ProviderFacility: provider.ProviderFacility,
        IsFavourite: updatedIsFavourite,
        MemberID: effectiveUser?.userData?.MemberID,
        ProviderType: selectedProviderType,
        DeviceType: effectiveUser?.userData?.DeviceType || "PatientPortal",
        EmailID: effectiveUser?.userData?.EmailID || "",
      };

      const response = await axios.post(
        Endpoints.SaveFavouriteNonPhysicianProviders,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: authHeaders }
      );

      if (response.data === "Success") {
        setProviderDetails((prev) => {
          const updated = prev.map((p, i) => ({
            ...p,
            IsFavourite: i === providerIndex ? updatedIsFavourite : "N",
          }));
          return updated.sort((a, b) => (a.IsFavourite === "Y" ? -1 : b.IsFavourite === "Y" ? 1 : 0));
        });
        toast.success(t('favouritestatusupated'));
      }
    } catch (err) {
      toast.error(t('failedtoupdatefavaourite'));
    }
  };

  const handleDoulasCategoryChange = (index, event) => {
    event.stopPropagation();
    const isSelectAll = doulasCategories[index].label === "All Categories";

    setDoulasCategories((prev) => {
      if (isSelectAll) {
        return prev.map((c) => ({ ...c, checked: event.target.checked }));
      } else {
        const updated = prev.map((c, i) => (i === index ? { ...c, checked: !c.checked } : c));
        const anyUnchecked = updated.some((c) => c.label !== "All Categories" && !c.checked);
        return updated.map((c) =>
          c.label === "All Categories" ? { ...c, checked: !anyUnchecked } : c
        );
      }
    });
  };

  const handleModalClose = () => {
    setShowNurseModal(false);
    setShowReproductiveModal(false);
  };

  const handleReproductiveYes = () => {
    setShowReproductiveModal(false);
    navigate(`/map-search${location.search}`, {
      state: {
        selectedProviderType: "Reproductive Endocrinologists/Infertility",
        userChoice: "Y",
        externalData: isExternal ? externalParams : null
      },
    });
  };

  const handleReproductiveModalClose = () => {
    setShowReproductiveModal(false);
    navigate("/map-search", {
      state: {
        selectedProviderType: "Reproductive Endocrinologists/Infertility",
        userChoice: "N",
      },
    });
  };
  const handleContinue = () => {
    const selectedCategories = doulasCategories.filter((c) => c.checked).map((c) => c.label);
    if (selectedCategories.length === 0) {
      setModalMessage(t('selectcategory'));
      setShowNurseModal(true);
      return;
    }
    navigate(`/map-search${location.search}`, {
      state: { 
        selectedProviderType: "Doulas", 
        selectedCategories,
        externalData: isExternal ? externalParams : null 
      },
    });
  };

  const handleBackClick = () => {
    // NEW: no back button behavior in external mode
    // if (isExternal) return;
    setShowProviderDetails(false);
    setShowDoulasCategories(false);
    setProviderDetails([]);
    if (!showProviderDetails) {
      navigate(-1);
    }
  };

  const handleCancelClick = () => setShowModal(false);

  const logChatActivity = async ({ ProviderType, Provider, link }) => {
    const params = {
      EmailID: effectiveUser?.userData?.EmailID || "",
      Activity: `${ProviderType}:${Provider}:${link}`,
      DeviceType: effectiveUser?.userData?.DeviceType || "PatientPortal",
    };
    try {
      const response = await axios.post(
        Endpoints.CallRecoderLog,
        { _Params: JSON.stringify(params) },
        { headers: { ...authHeaders, Connection: "close", Accept: "*/*" } }
      );
      if (!response.data) console.warn("Log not saved: Empty response from server.");
    } catch (err) {
      console.error("Error saving log:", err);
    }
  };

  const handleOkClick = () => {
    setShowModal(false);
    if (redirectLink) window.open(redirectLink, "_blank");
  };

  const getProviderInfoMessage = (type) => {
    switch (type) {
      case "Donor Egg Banks":
        return "Get started on your egg-donor journey with Lucina.";
      case "At Home Semen Analysis kits":
        return "Take control of your fertility journey with an at-home semen analysis kit.";
      case "Cryostorage Facilities":
        return "Get started on your cryostorage journey.";
      case "Surrogacy Agencies":
      case "Surrogacy Agencies contracted with WIN":
        return isHighmarkPortal
          ? "Take the first step of your surrogacy journey with one of these vetted surrogacy agencies."
          : "Take the first step of your surrogacy journey with one of these WIN-vetted surrogacy agencies.";
      case "surrogacy journey with one of these WIN.":
      case "surrogacy journey with one of these.":
        return isHighmarkPortal ? "Vetted surrogacy agencies." : "Vetted surrogacy agencies by WIN.";
      case "Adoption and Assisted Reproductive Technologies Attorneys":
        return (
          <>
            Your family-building journey deserves expert legal protection.{" "}
            <strong>
              Tap the below to explore your options for comprehensive legal support specializing in adoption and assisted reproductive technologies
            </strong>
            —and ensure you’re covered every step of the way.<br />
        <strong>
           Get in touch with your expert family building coach. They can assist with adoption agency referrals and more.
      </strong>          
      </>
        );
      case "Genetics Labs":
        return isHighmarkPortal ? "Explore your genetics lab options." : "Explore your genetics lab options with WINGenetics.";
      default:
        return null;
    }
  };

  // Add effect to prevent browser back in external mode
  useEffect(() => {
    if (isExternal) {
      // Push an extra entry to the history stack
      window.history.pushState(null, "", window.location.pathname + window.location.search);

      // Prevent browser back
      const handlePopState = (event) => {
        event.preventDefault();
        // Push another state to prevent going back
        window.history.pushState(null, "", window.location.pathname + window.location.search);
      };

      window.addEventListener('popstate', handlePopState);
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [isExternal]);

  return (
    <>
      <ToastContainer />
      <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={() => setShowModal(false)}
        onOkay={handleOkClick}
        showConfirmButtons={showConfirmButtons}
      />

      <div className="container-fixed my-5 my-sm-1">

        {/* NEW: hide Back button if external */}
        {isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
              <span>
                <i className="bi bi-chevron-left"></i>
              </span>
            </button>       
            <h2 className="page-heading">Find a provider near you</h2>
          </div>
          :
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            {shouldShowBack  && ( 
              <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                  <i className="bi bi-chevron-left"></i>
                  {t('Back')}
                </span>
              </button>
            )}  
            <h2 className="page-heading">{t('findcare')}</h2>
          </div>
        }
        <div className="col-md-12 mt-2 mt-md-3">
          <div className="favorites-wrapper favorites-blocks-with-gap">
            {showProviderDetails ? (
              <>
                {getProviderInfoMessage(selectedProviderType) && (
                  <div className="provider-info-message mb-0">
                    <p>{getProviderInfoMessage(selectedProviderType)}</p>
                  </div>
                )}
                {providerDetails.map((provider, index) => (
                  <div
                    key={index}
                    className="favorites-details-wrapper mb-0"
                    onClick={(e) => {
                      if (!e.target.closest(".no-redirect")) {
                        logChatActivity({
                          ProviderType: selectedProviderType,
                          Provider: provider.ProviderFacility,
                          link: provider.redirect_url
                        });
                        window.open(provider.redirect_url, "_blank");
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="favorites-pharmasy-name">
                      {!provider.ProviderFacility ? (
                        <img
                          alt={provider.ProviderFacility}
                          className="favorites-pharmasy-logo"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            logChatActivity({
                              ProviderType: selectedProviderType,
                              Provider: provider.ProviderFacility,
                              link: provider.redirect_url
                            });
                            window.open(provider.redirect_url, "_blank");
                          }}
                        />
                      ) : (
                        <span
                          className="provider-text"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(provider.redirect_url, "_blank");
                          }}
                        >
                          {provider.ProviderFacility}
                        </span>
                      )}
                      <div
                        className="no-redirect"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(index);
                        }}
                      >
                        {provider.IsFavourite === "Y" ? (
                          <i className="favorites-icon favsaved"></i>
                        ) : (
                          <i className="favorites-icon"></i>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="find-provider-wrapper mt-0 mb-5">
                {providers.length > 0 ? (
                  providers.map((provider, index) => (
                    <React.Fragment key={index}>
                      <div
                        className="schedule-block support-services-highmark"
                        onClick={(e) => {
                          if (
                            !e.target.closest(".no-redirect") &&
                            !e.target.closest(".doulas-categories-wrapper")
                          ) {
                            handleProviderClick(provider);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="schedule-block-left-logo"></span>
                        <div className="service-content find-provider">
                          <h4>{provider.ProviderType}</h4>
                        </div>

                        {provider.ProviderType === "Doulas" && showDoulasCategories && (
                          <div
                            className="doulas-categories-wrapper no-redirect"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="doulas-categories">
                              {doulasCategories.map((category, catIndex) => (
                                <div key={catIndex} className="doulas-category">
                                  <label>
                                    <input
                                      type="checkbox"
                                      className="form-check-input no-redirect"
                                      checked={category.checked}
                                      onChange={(e) => handleDoulasCategoryChange(catIndex, e)}
                                    />
                                    {category.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                            <button
                              className="win-btn-secondary no-redirect"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleContinue();
                              }}
                            >
                              {t('continue')}
                            </button>
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ))
                ) : (
                  <p>
                    <div className="loading-container">
                      <div className="loading"></div>
                      <h2 className="loading-text">{t("loading")}</h2>
                    </div>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

      </div>

        <ErrorModal show={showNurseModal} message={modalMessage} onClose={handleModalClose} />
        <ErrorModal
          show={showReproductiveModal}
          message={modalMessage}
          onClose={handleReproductiveModalClose}
          onOkay={handleReproductiveYes}
          showConfirmButtons={true}
        />
        {isChatVisible && <ChatBotWindow />}
    </>
  );
};

export default ProviderList;
